import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" }
const _hoisted_3 = { class: "space-y-4 sm:space-y-3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-md 2xl:text-lg leading-6 font-medium text-gray-900" }
const _hoisted_6 = { class: "divide-y space-y-3 sm:space-y-5" }
const _hoisted_7 = { class: "pt-5" }
const _hoisted_8 = { class: "pt-5" }
const _hoisted_9 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 items-center sm:border-t sm:border-gray-200 pt-5" }
const _hoisted_10 = {
  for: "duration",
  class: "flex flex-col text-sm font-medium text-gray-700"
}
const _hoisted_11 = { class: "max-w-2xl text-xs text-gray-400" }
const _hoisted_12 = { class: "sm:col-span-2 mt-2 sm:mt-0" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", null, "15", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", null, "30", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", null, "45", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", null, "60", -1)
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "pt-5" }
const _hoisted_20 = { class: "flex" }

import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { format, parse, subDays } from "date-fns";
import { Form } from "vee-validate";
import { ref, computed, onMounted, Ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import * as yup from "yup";
import { segmentAnalytics } from "@/assets/scripts";
import DateField from "@/components/forms/DateField.vue";
import TimeField from "@/components/forms/TimeField.vue";
import NavigationComponent from "@/components/layout/NavigationComponent.vue";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import MainButton from "@/components/other/MainButton.vue";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import InfoTooltip from "@/components/tooltips/TooltipInfo.vue";
import { useCustomToast } from "@/composables/toast";
import StreamRepository from "@/repositories/StreamRepository";
import logger from "@/services/logger";
import CameraItemLayout from "@/views/camera/components/CameraItemLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Period',
  setup(__props) {

onMounted(() => {
  segmentAnalytics("Period Visit");
});

const duration = ref("15") as Ref<string>;
const loading = ref(false) as Ref<boolean>;
const error = ref(false) as Ref<boolean>;
const videoUrl = ref(null) as Ref<string | null>;
const toast = useCustomToast();
const { t } = useI18n();
const route = useRoute();
const customer = useCurrentCustomerName();
const site = useCurrentSiteId();

const schema = computed(() =>
  yup.object({
    startTimestampDate: yup
      .date()
      .nullable()
      .required(t("err.required"))
      .max(
        maxDate.value,
        t("err.err_future_date", { maxDate: format(maxDate.value, "yyyy-MM-dd") }),
      ),
    startTimestampTime: yup
      .string()
      .test("is-valid-time", t("err.inputs.time_wrong_format"), (value: string | undefined) => {
        if (typeof value === "undefined") {
          return false;
        }

        const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return timeRegex.test(value);
      })
      .required(t("err.required")),
  }),
);

const minDate = computed(() => {
  return subDays(new Date(), 7);
});

const maxDate = computed(() => {
  return new Date();
});

onMounted(() => {
  segmentAnalytics("Period Visit");
});

const queryStreamingUrl = async (values: Record<string, number | Date>) => {
  loading.value = true;
  const startDate = format(values.startTimestampDate, "yyyy-MM-dd");
  const startTime = values.startTimestampTime;
  const startDateTime = parse(`${startDate} ${startTime}`, "yyyy-MM-dd HH:mm", new Date());
  StreamRepository.loadPlaybackUrl(
    customer,
    site,
    route.params.camera_id as string,
    startDateTime,
    parseInt(duration.value),
  )
    .then((url) => {
      videoUrl.value = url;
    })
    .catch((err) => {
      error.value = true;
      logger.error(err);
    })
    .finally(() => {
      loading.value = false;
      if (!videoUrl.value) {
        error.value = true;
        toast.warning(t("err.no_streaming_found"));
      }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigationComponent, {
    activeTag: _ctx.$t('app_features.period')
  }, {
    default: _withCtx(() => [
      _createVNode(CameraItemLayout, null, {
        contentLeft: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(OculaiVideoPlayer, {
              loading: loading.value,
              src: videoUrl.value,
              noSrcMessage: error.value ? _ctx.$t('err.no_streaming_found') : _ctx.$t('camera.period.info_text'),
              hls: true
            }, null, 8, ["loading", "src", "noSrcMessage"])
          ])
        ]),
        contentRight: _withCtx(() => [
          _createVNode(_unref(Form), {
            onSubmit: queryStreamingUrl,
            class: "space-y-3 sm:space-y-5 divide-y divide-gray-200",
            validationSchema: schema.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("camera.period.playback_period")), 1),
                    _createVNode(InfoTooltip, null, {
                      text: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("camera.period.info_text")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(DateField, {
                        name: "startTimestampDate",
                        label: _ctx.$t('camera.period.date'),
                        minDate: minDate.value,
                        maxDate: maxDate.value,
                        inlineField: true
                      }, null, 8, ["label", "minDate", "maxDate"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(TimeField, {
                        name: "startTimestampTime",
                        label: _ctx.$t('camera.period.time'),
                        inlineField: true
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.$t("camera.period.duration")) + " ", 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("camera.period.in_minutes")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("select", {
                          id: "duration",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((duration).value = $event)),
                          disabled: loading.value,
                          class: "oai-inputs max-w-lg sm:max-w-xs"
                        }, _hoisted_18, 8, _hoisted_13), [
                          [_vModelSelect, duration.value]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(MainButton, {
                    label: _ctx.$t('camera.period.play'),
                    type: "submit",
                    color: "yellow",
                    class: "mx-0 sm:mr-0 mt-0"
                  }, {
                    default: _withCtx(() => [
                      (loading.value)
                        ? (_openBlock(), _createBlock(LoadingSpinner, {
                            key: 0,
                            size: "w-5 h-5",
                            color: "white",
                            class: "mr-2"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validationSchema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["activeTag"]))
}
}

})